<template>
  <div class="pay-success-container">
    <!-- 支付成功图标 -->
    <div class="success-icon">
      <i class="icon-success"></i>
    </div>
    
    <!-- 支付成功标题 -->
    <div class="success-title">支付成功</div>
    
    <!-- 提示信息 -->
    <div class="tips">
      <p>如有疑问，请联系规划师</p>
    </div>
  </div>
</template>


<style scoped>
.pay-success-container {
  padding: 100px 20px 40px;
  text-align: center;
  background-color: #fff;
  min-height: 100vh;
  box-sizing: border-box;
}

.success-icon {
  margin: 0 auto 30px;
  width: 90px;
  height: 90px;
  border-radius: 50%;
  background-color: #f0f9ff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-success {
  width: 45px;
  height: 45px;
  background-color: #19be6b;
  border-radius: 50%;
  position: relative;
}

.icon-success::before {
  content: '';
  position: absolute;
  top: 20px;
  left: 12px;
  width: 14px;
  height: 7px;
  border-left: 3px solid #fff;
  border-bottom: 3px solid #fff;
  transform: rotate(-45deg);
}

.success-title {
  font-size: 26px;
  color: #333;
  font-weight: bold;
  margin-bottom: 15px;
}

.tips {
  color: #999;
  font-size: 14px;
}
</style>